export function digitsSlider() {
    let slider = $('.digits-slider');
    slider.slick({
        infinite: true,
        cssEase: 'ease-in-out',
        speed: 300,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 2600,
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/digitsSlider.js